import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Header, Segment, Loader, Icon, Modal, Form, Image } from 'semantic-ui-react'
import { DragDrop } from '@uppy/react'
import Uppy from '@uppy/core'
import AwsS3Multipart from '@uppy/aws-s3-multipart'

import AuthActions from 'Redux/AuthRedux'

import DebugConfig from 'Config/DebugConfig'
import Alert from 'Components/Alert'
import ConfirmPopup from 'Components/ConfirmPopup'

import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css'

const ThumbnailImage = 'https://react.semantic-ui.com/images/wireframe/image.png'

const uppy = Uppy({
  autoProceed: false,
  allowMultipleUploads: true,
  restrictions: {
    maxFileSize: null,
    maxNumberOfFiles: 1,
    minNumberOfFiles: 1,
    allowedFileTypes: ['image/*']
  }
})


uppy.use(AwsS3Multipart, {
  // default is "/s3"
  serverUrl: DebugConfig.isDev ? 'http://localhost:3001' : 'https://api.seekrev.com'
})

class AvatarUpload extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalOpen:false,
      avatarPreview: null,
      isUploading: false
    }
  }

  componentDidMount () {
    this.props.profileRequest()
  }

  componentWillMount () {
    uppy.on('file-added', this.onFileAdd)
    uppy.on('complete', this.onUploadComplete)
  }

  componentWillUnMount () {
    uppy.off('file-added', this.onFileAdd)
    uppy.off('complete', this.onUploadComplete)
    this.removeUploadedFile()
  }

  onUploadComplete = (result, file, data, uploadURL) => {
    window.URL.revokeObjectURL(this.state.avatarPreview)
    this.setState({ avatarPreview: null, isUploading: false })

    if (result.successful.length === 1) {
      uppy.removeFile(result.successful[0].id)
      const uploadedFileData = result.successful.map(file => {
        return JSON.stringify({
          // extract key without prefix
          id: file.uploadURL.match(/\/cache\/([^?]+)/)[1],
          storage: 'cache',
          metadata: {
            filename: file.name,
            size: file.data.size,
            mime_type: file.data.type,
          }
        })
      })

      this.props.profileUpdateRequest({
        avatar: uploadedFileData[0]
      })
    }
  }

  removeUploadedFile = () => {
    window.URL.revokeObjectURL(this.state.avatarPreview)
    this.setState({ avatarPreview: null, isUploading: false })
    uppy.cancelAll()
    // TODO (atinder) Implement this method
    // this.props.clearErrors()
  }

  onUpload = () => {
    uppy.upload()
    this.setState({ isUploading: true })
    this.handleClose()
  }

  onFileAdd = (file) => {
    const avatarPreview = window.URL.createObjectURL(file.data)
    this.setState({
      avatarPreview
    });
  }

  initializeState = () => {
    this.setState({
      avatarPreview: null,
      isUploading: false
    })
  }

  onRemove = () => {
    // reset uppy
    uppy.reset()
    this.props.profileUpdateRequest({
      avatar: null
    })
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  render() {
    return (
      <Segment>
        <Alert color='red' messages={this.props.error} />
        <Form>
          <Header as='h2'>
          <Icon name='camera' color='grey' />
            <Header.Content>
              Avatar
            </Header.Content>
          </Header>
          <Loader active={this.props.fetching || this.state.isUploading} />
          <Form.Field>
            <Image
              src={this.props.userData.avatarUrl || ThumbnailImage}
              size='medium'
            />
          </Form.Field>

          <Modal
            trigger={<Button
              primary
              type='submit'
              disabled={this.props.fetching || this.state.isUploading}
              onClick={this.handleOpen}>{
                this.props.userData.avatarUrl
                ? 'Update Avatar'
                : 'Add Avatar'
              }</Button>}
            open={this.state.modalOpen}
            onOpen={this.initializeState}
            onClose={this.handleClose}
            size='small'
          >
            <Header icon='user' content='Upload Profile Pic' />
            <Modal.Content>
              <Form>
            {
              this.state.avatarPreview ? 
              <Image
                src={this.state.avatarPreview}
                size='medium'
                centered
              />
              :  (<DragDrop
                  height="100%"
                  width="100%"
                  uppy={uppy}
                  note='Drop or Select a Profile Pic'
                  locale={{
                    strings: {
                    dropHereOr: ''
                  }
                  }}
                />)
            }
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button color='red' basic onClick={this.handleClose}>
                Cancel
              </Button>
              <Button 
                inverted
                color='green'
                onClick={this.onUpload}
                disabled={!this.state.avatarPreview}
                >
                Upload
              </Button>
            </Modal.Actions>
          </Modal>

          {
          this.props.userData.avatarUrl ?  
          <ConfirmPopup
            trigger={
              <Button
                color='red' 
                basic
                disabled={this.props.fetching || this.state.isUploading}
              >
                Remove Avatar
              </Button>
            }
            position='bottom right'
            onConfirm={this.onRemove}
          />
          : null
         }
        </Form>
      </Segment>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  fetching: state.auth.updateFetching || state.auth.fetching,
  error: state.auth.updateError
})

const mapDispatchToProps = (dispatch) => ({
  profileUpdateRequest: (params) =>
    dispatch(AuthActions.profileUpdateRequest(params)),
  profileRequest: (params) =>
    dispatch(AuthActions.profileRequest())
})

export default connect(mapStateToProps, mapDispatchToProps)(AvatarUpload)



// WEBPACK FOOTER //
// ./src/Components/AvatarUpload.js